module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ijiNu"))).then(() => parcelRequire('8rm4T'));